var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChecklisttask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.997 3h-4.18c-.42-1.16-1.52-2-2.82-2-1.299 0-2.399.84-2.819 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h13.998a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm-7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM7 7h9.998V5h2v14H4.999V5h2v2zm.5 6.5 1.5-1.5 1.999 2 4.5-4.5 1.499 1.5-5.999 6-3.5-3.5z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecklisttask);
export default __webpack_public_path__ + "static/media/icon _ checklist task.de07be27bc608fb69063b92210492171.svg";
export { ForwardRef as ReactComponent };